import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const TOKEN_EXPIRY_GRACE_SECONDS = 30;

const decodeBase64Url = (value) => {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  return decodeURIComponent(
    atob(padded)
      .split("")
      .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
      .join("")
  );
};

export function isTokenExpired(token) {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return true;
    const payload = JSON.parse(decodeBase64Url(parts[1]));
    if (!payload?.exp || typeof payload.exp !== "number") return false;
    const nowInSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= nowInSeconds + TOKEN_EXPIRY_GRACE_SECONDS;
  } catch {
    return true;
  }
}

export function hasValidAuthToken(store) {
  const authToken = localStorage.getItem("authToken");
  if (!authToken) return false;
  if (isTokenExpired(authToken)) {
    store.commit("tenantId/LOGOUT", undefined, { root: true });
    return false;
  }
  return true;
}

export function useAuth() {
  const store = useStore();
  const router = useRouter();

  const isAuthenticated = computed(() => hasValidAuthToken(store));

  async function logout() {
    try {
      const response = await store.dispatch("auth/sendLogoutRequest");
      if (response?.data?.statusCode === 200) {
        await router.push("/login");
        window.location.reload();
      }
    } catch {
      await router.push("/login");
    }
  }

  return {
    isAuthenticated,
    logout,
  };
}
